import { c as _c } from "react/compiler-runtime";
import { EventListApiInterface } from 'modules/calendar/events/types/new-event-interface';
import { squareBracketsToDots } from 'modules/calendar/utils/square-brackets-to-dots';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface';
import { getFilterQueryString } from 'shared/utils/api/get-filter-query-string';
import { getPaginationAndFilterQueryString } from 'shared/utils/api/get-pagination-and-filter-query-string';
import { baseFetcher } from 'shared/utils/http-client';
import { EVENTS_API } from '../api/events-api';
import { EventFilterInterface } from '../types/calendar-filter-interface';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
interface UseEventInterface extends SwrPaginationInterface {
  filter: EventFilterInterface;
}
export function useEvents(t0) {
  const $ = _c(13);
  const {
    limit,
    pagination,
    filter
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== filter || $[2] !== limit || $[3] !== pagination || $[4] !== user) {
    t2 = () => {
      if (user) {
        return [`${EVENTS_API}/list?${squareBracketsToDots(getPaginationAndFilterQueryString({
          limit,
          pagination,
          filter
        }))}`, RequestModuleEnum.Calendar];
      }
    };
    $[1] = filter;
    $[2] = limit;
    $[3] = pagination;
    $[4] = user;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data: events,
    mutate
  } = useControlledSwr(t2, fetcher);
  let t3;
  if ($[6] !== filter || $[7] !== user) {
    t3 = () => {
      if (user) {
        return [`${EVENTS_API}/count?pagination.limit.${squareBracketsToDots(getFilterQueryString({
          filter
        }))}`, RequestModuleEnum.Calendar];
      }
      return null;
    };
    $[6] = filter;
    $[7] = user;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    data: counter
  } = useControlledSwr(t3, baseFetcher);
  let t4;
  if ($[9] !== counter || $[10] !== events || $[11] !== mutate) {
    t4 = {
      events,
      mutate,
      counter
    };
    $[9] = counter;
    $[10] = events;
    $[11] = mutate;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}